/* src/app/shared/components/ag-button/ag-button.component.scss */
.ag-button {
  box-sizing: border-box;
  line-height: normal;
  padding: 0;
  border: 1px solid transparent;
  white-space: nowrap;
}
.ag-button.padded {
  padding: 0 16px;
}
.ag-button:hover {
  transition: all 0.2s ease-in-out;
}
.ag-button:disabled {
  opacity: 0.6;
}
.ag-button.ag-size-default {
  height: 38px;
  min-width: 38px;
  border-radius: 10px;
}
.ag-button.ag-size-small {
  height: 28px;
  min-width: 28px;
  border-radius: 8px;
  font-size: 12px;
}
.ag-button.ag-size-large {
  height: 50px;
  min-width: 50px;
  border-radius: 20px;
  min-width: 160px;
}
.ag-button.ag-type-default {
  box-shadow: 0 1px 3px 0 rgba(140, 140, 140, 0.3);
}
.ag-button.ag-type-default.ag-color-primary {
  background-color: #61566e;
  color: #ffffff;
}
.ag-button.ag-type-default.ag-color-primary:hover {
  opacity: 0.9;
}
.ag-button.ag-type-default.ag-color-secondary {
  background-color: #f1f1f1;
  color: #333333;
}
.ag-button.ag-type-default.ag-color-secondary:hover {
  opacity: 0.9;
}
.ag-button.ag-type-default.ag-color-success {
  background-color: #578a6b;
  color: #ffffff;
}
.ag-button.ag-type-default.ag-color-success:hover {
  opacity: 0.9;
}
.ag-button.ag-type-text {
  background: none;
}
.ag-button.ag-type-text:hover {
  background-color: #f1f1f1;
}
.ag-button.ag-type-text.ag-color-primary {
  color: #61566e;
}
.ag-button.ag-type-text.ag-color-secondary {
  color: #333333;
}
.ag-button.ag-type-text.ag-color-success {
  color: #578a6b;
}
.ag-button.ag-type-outline {
  background-color: #fdfdfd;
}
.ag-button.ag-type-outline:hover {
  background-color: #f1f1f1;
}
.ag-button.ag-type-outline.ag-color-primary {
  color: #61566e;
  border-color: #61566e;
}
.ag-button.ag-type-outline.ag-color-secondary {
  color: #333333;
  border-color: #333333;
}
.ag-button.ag-type-outline.ag-color-success {
  color: #578a6b;
  border-color: #578a6b;
}
.ag-button.ag-type-outline.ag-color-light {
  color: #fdfdfd;
  border-color: #fdfdfd;
  background-color: transparent;
}
/*# sourceMappingURL=ag-button.component.css.map */
